<template>
  <div
    class="income-container"
    @click="$router.push({ name: 'StoreSellData' })"
  >
    <div class="head van-hairline--bottom">
      <div class="tit">
        <span :class="{ active: active === 0 }">今日</span>
        <!-- <span :class="{ active }">昨日</span>
        <span :class="{ active }">本周</span>
        <span :class="{ active }">本月</span> -->
      </div>
      <div class="read-more">
        <img :src="require('@/assets/setting/箭头1.svg')" alt="" />
      </div>
    </div>
    <div class="statistics">
      <div class="item">
        <div class="val">{{ storeData.salesVolume || 0 }}</div>
        <div class="tit">销售额(元)</div>
      </div>
      <div class="item">
        <div class="val">{{ storeData.anticipatedRevenue || 0 }}</div>
        <div class="tit">预计收入(元)</div>
      </div>
      <div class="item">
        <div class="val">{{ storeData.orderNum || 0 }}</div>
        <div class="tit">所有订单(笔)</div>
      </div>
      <div class="item">
        <div class="val">{{ storeData.buyNum || 0 }}</div>
        <div class="tit">购买人数(人)</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreData } from "../webApi";
export default {
  data() {
    return {
      active: 0,
      storeData: {},
    };
  },
  created() {
    getStoreData().then(({ data }) => {
      this.storeData = data;
    });
  },
};
</script>

<style lang="less" scoped>
.income-container {
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
  border-radius: 16px;
  margin-bottom: 16px;
  .head {
    display: flex;
    justify-content: space-between;
    padding: 20px 18px;
    .tit {
      font-size: 24px;
      line-height: 34px;
      span {
        color: #808080;
        &.active {
          color: #333;
          font-weight: bold;
        }
        & + span {
          margin-left: 20px;
        }
      }
    }
    .read-more {
      font-size: 24px;
      line-height: 34px;
      align-items: center;
      display: flex;
      color: #aeaeae;
      img {
        display: inline-block;
        height: 18px;
        margin-left: 20px;
      }
    }
  }
  .statistics {
    padding: 22px 18px 30px;
    display: flex;
    .item {
      width: 25%;
      .val {
        font-size: 32px;
        line-height: 44px;
        color: #e82035;
        font-weight: bold;
      }
      .tit {
        padding-top: 6px;
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
}
</style>